import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiModule } from '../api.module';
import { ApiMailHelperPipe, ApiMailHelperUnpurePipe } from './mail-helper.pipe';

@NgModule({
  declarations: [ApiMailHelperPipe, ApiMailHelperUnpurePipe],
  imports: [CommonModule, ApiModule],
  exports: [ApiMailHelperPipe, ApiMailHelperUnpurePipe],
  providers: [ApiMailHelperPipe],
})
export class ApiMailModule {}
